import React from 'react';
import { sanitizeEmailHtml } from '../../utils/sanitize';
import { humanize } from './automationFormat';
import AutomationStepList from './AutomationStepList';

const BRANCH_KEYS = new Set(['then_actions', 'else_actions', 'then_steps', 'else_steps']);

function ConfigValue({ name, value }) {
  if ((name === 'content' || name === 'body') && typeof value === 'string') {
    return (
      <div
        className="whitespace-pre-wrap break-words rounded border border-border bg-background p-2 text-foreground"
        dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(value) }}
      />
    );
  }
  if (typeof value === 'object') {
    return <pre className="whitespace-pre-wrap break-words text-foreground">{JSON.stringify(value, null, 2)}</pre>;
  }
  return <span className="whitespace-pre-wrap break-words text-foreground">{String(value)}</span>;
}

/** Full executable config, including recipients, content and both conditional branches. */
export default function AutomationStepDetails({ config = {}, depth = 0 }) {
  return (
    <div className="space-y-2 border-t border-border pt-2">
      <dl className="space-y-2">
        {Object.entries(config)
          .filter(([name, value]) => value !== null && value !== undefined && !BRANCH_KEYS.has(name))
          .map(([name, value]) => (
            <div key={name}>
              <dt className="mb-0.5 font-medium text-muted-foreground">{humanize(name)}</dt>
              <dd><ConfigValue name={name} value={value} /></dd>
            </div>
          ))}
      </dl>
      {depth < 5 && Object.entries(config).filter(([name]) => BRANCH_KEYS.has(name)).map(([name, items]) => (
        <div key={name}>
          {items?.length
            ? <AutomationStepList title={humanize(name)} items={items} depth={depth + 1} />
            : <p className="text-muted-foreground">{humanize(name)}: No Steps</p>}
        </div>
      ))}
    </div>
  );
}
